export default "__VITE_ASSET__OEwSNo8S__"